// Texts of the Social & Custom Links components, from the roleChangeRequest
// catalogue (all five languages); English only as the last fallback.
const FALLBACK = {
  socialLinks: "Social & Custom Links",
  socialLinksHelp: "Optional. Add as many links as you like: YouTube, Facebook, Instagram, TikTok, LinkedIn, portfolio, GitHub, website…",
  addLink: "Add Link",
  linkName: "Name",
  linkNamePlaceholder: "e.g. YouTube Yvox",
  linkUrl: "URL",
  removeLink: "Remove Link",
  copyLink: "Copy Link",
  linkCopied: "Link Copied",
  invalidUrl: "Invalid URL. Enter a full address starting with http:// or https://.",
  linkNameRequired: "Enter a name for this link.",
  linkUrlRequired: "Enter the URL of this link.",
  linkNameTooLong: "The name can contain at most {max} characters.",
  tooManyLinks: "You can add up to {max} links.",
  noSocialLinks: "No links provided.",
  copyUnavailable: "Copy is not available in this browser.",
};

export const applicationLinksText = (infoSource) => (key) =>
  infoSource?.laguangeElakay?.("roleChangeRequest", infoSource.languageAPI)?.[key] ||
  infoSource?.laguangeElakay?.("roleChangeRequest", [])?.[key] ||
  FALLBACK[key] || key;
